export const getDictionary = async (locale: string) => {
  try {
    return (await import(`evcharging/i18n/${locale}`)).default;
  } catch (e) {
    return {};
  }
};
